import React from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import {
    Brush,
    Clipboard,
    Lightbulb,
    People,
    PersonCircle, PersonPlus,
    Speedometer,
    Trophy
} from 'react-bootstrap-icons';
import {useAppSelector} from "../../app/store";
import {ADMIN_LANG} from "../../settings";
import DefaultLogo from '../../images/scope-white.svg';

const SidebarMenu = ({closeOffCanvas}: { closeOffCanvas: () => void }) => {
    const {full_name, user_id, logo} = useAppSelector((state) => state.profile);
    const location = useLocation();

    const isActive = (exactPath: string | null, startsWithPath: string | null = null) => {
        if (exactPath === '/admin' && location.pathname === exactPath) {
            return true;
        }
        if (startsWithPath && location.pathname.startsWith(startsWithPath)) {
            return true;
        }
        return false;
    };

    const handleNavigation = (url:string) => {
        // Directly navigate to the backend URL
        window.location.href = url;
    };

    const Logo = logo ? logo : DefaultLogo;

    return (
        <div className='flex-column nav'>
            <div className='logo-container'>
                <img className='img-fluid logo' src={Logo} alt='logo'/>
            </div>

            <div className={`nav-item ${isActive('/admin') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin' onClick={closeOffCanvas}>
                    <span className='sidebar-icon'><Speedometer/></span>
                    <span>{ADMIN_LANG.dashboard}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/games') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/games' onClick={closeOffCanvas}>
                    <span className='sidebar-icon'><Trophy/></span>
                    <span>{ADMIN_LANG.games}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/questions') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/questions' onClick={closeOffCanvas}>
                    <span className='sidebar-icon icon-question'><Lightbulb/></span>
                    <span>{ADMIN_LANG.questions}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/themes') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/themes' onClick={closeOffCanvas}>
                    <span className='sidebar-icon icon-question'><Brush/></span>
                    <span>{ADMIN_LANG.themes}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/users') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/users' onClick={closeOffCanvas}>
                    <span className='sidebar-icon'><PersonCircle/></span>
                    <span>{ADMIN_LANG.users}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/teams') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/teams' onClick={closeOffCanvas}>
                    <span className='sidebar-icon'><People/></span>
                    <span>{ADMIN_LANG.teams}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/forms') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/forms' onClick={closeOffCanvas}>
                    <span className='sidebar-icon'><Clipboard/></span>
                    <span>{ADMIN_LANG.forms}</span>
                </NavLink>
            </div>
            <div className={`nav-item ${isActive(null, '/admin/links') ? 'active' : ''}`}>
                <NavLink className='nav-link' to='/admin/links' onClick={closeOffCanvas}>
                    <span className='sidebar-icon'><PersonPlus/></span>
                    <span>{ADMIN_LANG.invitation_links}</span>
                </NavLink>
            </div>
            <hr className='pb-3'></hr>
            <NavLink to={`/admin/users/${user_id}`} className='nav-link small-link mb-1' onClick={closeOffCanvas}>
                <span className={'font-weight-bold'}><PersonCircle/> {full_name}</span>
            </NavLink>
            <div>
                <a
                    href='#'
                    className='nav-link small-link'
                    onClick={() => handleNavigation('/')}
                    role='button'
                >
                    <span>{ADMIN_LANG.back_to_site}</span>
                </a>
                <a
                    href='#'
                    className='nav-link small-link'
                    onClick={() => handleNavigation('/logout/')}
                    role='button'
                >
                    <span>{ADMIN_LANG.logout}</span>
                </a>
            </div>
        </div>
    );
};

export default SidebarMenu;